<template>
    <div>
        <div class="my-8 flex justify-center" v-if="loading">
            <spinner />
        </div>

        <template v-if="!loading">
            <div class="text-base sm:text-lg text-secondary my-4 flex">
                <router-link
                    tag="button"
                    :to="{ name: 'promotionEventDetail' }"
                    class="inline-block border-b-2 border-transparent mr-2 sm:mr-4 focus:outline-none"
                    activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
                >
                    {{ '抽獎詳情' }}
                </router-link>
                <router-link
                    tag="button"
                    :to="{ name: 'promotionEventHistory' }"
                    class="inline-block border-b-2 border-transparent mx-2 sm:mx-4 focus:outline-none"
                    activeClass="text-darkGrayishBlue border-darkGrayishBlue font-black"
                >
                    {{ '抽獎紀錄' }}
                </router-link>
            </div>
            <router-view></router-view>
        </template>
    </div>
</template>

<script>
import spinner from '../../components/spinner.vue';

export default {
    components: {
        spinner
    },
    data: () => ({
        loading: false
    }),
    async created() {
        this.loading = true;
        const eventId = this.$route.params.eventId;
        const promotionEvents = await this.$store.dispatch(
            'getPromotionEventList'
        );
        const event = (promotionEvents || []).find(
            p => p.prmtEvntId === eventId
        );
        if (!event) {
            this.$router.push({ name: 'pageNotFound' });
        }
        this.loading = false;
    }
};
</script>
